import { DynamicOptionsWithNumberAndSelection as DynamicOptionsWithNumberAndSelectionType } from '../../../../../types/Survey/Element'
import {
  DynamicOptionsWithNumberAndSelection as DynamicOptionsWithNumberAndSelectionAnswerType,
  DynamicOptionsWithNumberAndSelectionOption,
} from '../../../../../types/Survey/Answer/Element'
import { Props } from './types'
import Core from './Core'
import Number from '../../../../UI/Input/Number'
import Checkbox from '../../../../UI/Checkbox/Checkbox'
import { PlusIcon } from '@heroicons/react/24/solid'
import { getDynamicOptionsWithNumberAndSelectionOption } from '../../../../hooks/useSurveyAnswer/transformElementsToAnswers'
import Input from '../../../../UI/Input/Input'

const DynamicOptionsWithNumberAndSelection: React.FC<
  Props<DynamicOptionsWithNumberAndSelectionType, DynamicOptionsWithNumberAndSelectionAnswerType>
> = ({ element, answerElement, updateElement }) => {
  const update = (uuid: string, key: any) => (value: any) => {
    const dynamicOptionsWithNumberAndSelection = [...answerElement.dynamicOptionsWithNumberAndSelection]
    const index = dynamicOptionsWithNumberAndSelection.findIndex((a) => a.uuid === uuid)
    if (index !== -1) {
      const option: DynamicOptionsWithNumberAndSelectionOption = dynamicOptionsWithNumberAndSelection[index]
      option[key] = value
    }
    updateElement({ ...answerElement, dynamicOptionsWithNumberAndSelection })
  }

  const getName = (uuid: string): string => {
    const DynamicOptionsWithNumberAndSelection = answerElement.dynamicOptionsWithNumberAndSelection.find((a) => a.uuid === uuid)
    return DynamicOptionsWithNumberAndSelection?.name
  }

  const getNumber = (uuid: string): number => {
    const DynamicOptionsWithNumberAndSelection = answerElement.dynamicOptionsWithNumberAndSelection.find((a) => a.uuid === uuid)
    return DynamicOptionsWithNumberAndSelection?.number || 0
  }

  const getIsNormSelected = (uuid: string): boolean => {
    const DynamicOptionsWithNumberAndSelection = answerElement.dynamicOptionsWithNumberAndSelection.find((a) => a.uuid === uuid)
    return DynamicOptionsWithNumberAndSelection?.isNormSelected || false
  }

  const getIsActive = (uuid: string): boolean => {
    const DynamicOptionsWithNumberAndSelection = answerElement.dynamicOptionsWithNumberAndSelection.find((a) => a.uuid === uuid)
    return DynamicOptionsWithNumberAndSelection?.isActive || false
  }

  const add = () => {
    // add new answer
    const updatedAnswer = { ...answerElement }
    updatedAnswer.dynamicOptionsWithNumberAndSelection.push(getDynamicOptionsWithNumberAndSelectionOption())

    updateElement(updatedAnswer)
  }

  return (
    <div>
      <Core element={element} />
      <div className="flex flex-col gap-2 mt-5">
        {answerElement.dynamicOptionsWithNumberAndSelection.map((o) => {
          const isActive = getIsActive(o.uuid)

          return (
            <div className="flex gap-2 items-center" key={o.uuid}>
              <div className={`flex justify-center w-[40px] shrink-0`}>
                <Checkbox checked={isActive} onChange={update(o.uuid, 'isActive')} />
              </div>
              <div className={isActive ? `w-2/4 shrink-0` : 'w-full'}>
                <Input value={getName(o.uuid)} onChange={update(o.uuid, 'name')} disabled={!isActive} />
              </div>
              {isActive && (
                <>
                  <div className={`w-1/4`}>
                    <Number suffix={element.numberSuffix} value={getNumber(o.uuid)} onChange={update(o.uuid, 'number')} />
                  </div>
                  <div className={`w-fit`}>
                    <Checkbox checked={getIsNormSelected(o.uuid)} onChange={update(o.uuid, 'isNormSelected')} label={element.normLabel} />
                  </div>
                </>
              )}
            </div>
          )
        })}
        <div className="ml-auto w-6 aspect-square bg-cyan rounded-full flex items-center justify-center text-white cursor-pointer" onClick={add}>
          <PlusIcon className="fill-white w-5" />
        </div>
      </div>
    </div>
  )
}

export default DynamicOptionsWithNumberAndSelection
